
declare type TelegramInfo = {
  id: string
  hash: string
}

export const useTelegram = defineStore('useTelegram', () => {
  const telegramInfo = ref({
    id: '',
    hash: ''
  });
  const inMiniApp = ref(false);
  const backUrl = ref('');
  const tgHash = ref('');
  const setTelegramInfo = (info: TelegramInfo) => {
    telegramInfo.value = info;
  };
  const setInMiniApp = (v: boolean) => {
    inMiniApp.value = v;
    localStorage.setItem('inMiniApp', JSON.stringify(v));
  };
  const setBackUrl = (v: string) => {
    backUrl.value = v;
    localStorage.setItem('miniApp_backUrl', v);
  };
  const setTgHash = (v:string) => {
    tgHash.value = v;
    localStorage.setItem('miniApp_tgHash', v);
  };
  return {
    telegramInfo,
    setTelegramInfo,
    inMiniApp,
    setInMiniApp,
    backUrl,
    setBackUrl,
    tgHash,
    setTgHash
  };
});
